/**
 * Фокусируется на ref
 * @param HTMLElement (ref)
 */
var focusOnRef = function focusOnRef(refElement) {
  if (refElement) {
    refElement.focus();
  }
};

export default focusOnRef;